import {naturalSortByKey} from '@benchling/js-utils';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ALL_KEY} from 'models/managers/AllModelManager';
import {SingleValueFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pick from 'util/pick';
import {WorkflowTemplate} from 'workflows/WorkflowConstants';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface WorkflowTemplateFilterFormExtraProps {
  workflowTemplates: Array<WorkflowTemplate>;
}

interface WorkflowTemplateFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onRemove?: () => void;
}

interface EnhanceProps {
  workflowTemplates: Array<WorkflowTemplate>;
}

class AllWorkflowTemplateDataConnector extends DataConnector<WorkflowTemplateFilterFormProps, EnhanceProps> {
  enhanceProps(): EnhanceProps {
    return {
      workflowTemplates: this.getOrFetchRequired(ManagedModelType.ALL_WORKFLOW_TEMPLATES, ALL_KEY),
    };
  }

  renderLoading(): JSX.Element {
    return (
      <WorkflowTemplateFilterForm {...this.props} workflowTemplates={[]} isLoading={true} isDisabled={true} />
    );
  }
}

export function WorkflowTemplateFilterForm(
  props: WorkflowTemplateFilterFormProps & WorkflowTemplateFilterFormExtraProps
): JSX.Element {
  const workflowTemplates = props.workflowTemplates;
  const optionDatas: Array<OptionData> = [
    {name: 'Any template', value: null},
    ...naturalSortByKey(
      workflowTemplates.map((workflowTemplate) => ({
        name: workflowTemplate.name,
        value: workflowTemplate.id,
      })),
      'name'
    ),
  ];

  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText('Template', optionDatas, props.filter)}
      filterStyle={props.filterStyle}
      isMulti={false}
      isSearchable={true}
      onChangeValue={(value: string) => {
        props.onChangeFilter({...props.filter, value});
      }}
      onRemove={props.onRemove}
      optionDatas={optionDatas}
      value={props.filter.value}
    />
  );
}

export default AllWorkflowTemplateDataConnector.connect(WorkflowTemplateFilterForm);
